import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { ADD_NEGOTIATION_ACTION } from "../../redux/Action/actionTypes";
import { useDispatch } from "react-redux";
import "../NewActionCard/newActionCard.scss";
import { getNegotiationActions } from "../../redux/Action/Action";

const NewActionCard = () => {
  const [modal, setModal] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [actionType, setActionType] = useState("");
  const [touched, setTouched] = useState({
    name: false,
    description: false,
  });
  const dispatch = useDispatch();
  const toggle = () => {
    setModal(!modal);
    if (!modal) {
      // Reset when opening
      setName("");
      setDescription("");
      setActionType("");
      setTouched({ name: false, description: false });
    }
  };
  const isNameInvalid =
    name.length > 50 || (touched.name && name.trim() === "");
  const isDescriptionInvalid =
    description.length > 1000 ||
    (touched.description && description.trim() === "");

  const handleSave = () => {
    if (isNameInvalid || isDescriptionInvalid || !actionType) return;
    const newAction = {
      name: name.trim(),
      description: description.trim(),
      type: actionType,
    };

    dispatch({
      type: ADD_NEGOTIATION_ACTION,
      payload: { newAction },
      meta: {
        onSuccess: () => {
          dispatch(getNegotiationActions());
        },
      },
    });

    // Reset form and close

    toggle();
  };

  return (
    <div>
      <button className="AddAction-button" onClick={toggle}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="17"
          height="17"
          fill="currentColor"
          className="bi bi-plus-lg"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
          />
        </svg>
        Add Custom action
      </button>
      <Modal
        isOpen={modal}
        toggle={toggle}
        size="sm"
        style={{ maxWidth: "400px" }}
        className="custom-modal"
      >
        <ModalHeader toggle={toggle}>Add new action</ModalHeader>
        <ModalBody className="popup-body">
          <Form>
            <FormGroup className="mb-2">
              <Label for="name" className="mb-1">
                Please name the new action
              </Label>
              <Input
                type="text"
                id="name"
                bsSize="sm"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onBlur={() => setTouched((prev) => ({ ...prev, name: true }))}
                invalid={isNameInvalid}
              />
              <FormFeedback>
                {name.length > 50 ? "Max 50 characters." : "Required."}
              </FormFeedback>
            </FormGroup>
            <FormGroup className="mb-2">
              <Label for="description" className="mb-1">
                Please describe the new action
              </Label>
              <Input
                type="textarea"
                id="description"
                bsSize="sm"
                rows="2"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                onBlur={() =>
                  setTouched((prev) => ({ ...prev, description: true }))
                }
                invalid={isDescriptionInvalid}
              />
              <FormFeedback>
                {description.length > 1000
                  ? "Max 1000 characters."
                  : "Required."}
              </FormFeedback>
            </FormGroup>
            <FormGroup className="mb-2">
              <Label for="actionType" className="mb-1">
                Please select whether the action is Preparation, Negotiation or
                Finalization
              </Label>
              <Input
                type="select"
                id="actionType"
                bsSize="sm"
                value={actionType}
                onChange={(e) => setActionType(e.target.value)}
              >
                <option value="">-- Select --</option>
                <option value="Preparation">Preparation</option>
                <option value="Negotiation rounds">Negotiation</option>
                <option value="Finalization">Finalization</option>
              </Input>
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter className="py-2">
          <Button color="secondary" size="sm" onClick={toggle}>
            Cancel
          </Button>
          <Button
            color="primary"
            size="sm"
            onClick={handleSave}
            disabled={isNameInvalid || isDescriptionInvalid || !actionType}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default NewActionCard;
